<template>
	<div class="role_list">
		<!-- 角色栏 -->
		<div class="role">
			<div style="display: flex; align-items: center;  justify-content: space-between; margin-bottom: 20px;">
				<div style="color: #515A6E; font-weight: bold;">角色</div>
				<Button type="primary" @click="addRoleClick">+添加角色</Button>
			</div>
			<div v-for="(item,index) in roleList" :key="index"
				 class="role-li" :class="{'active' : activeId == item.id}"  @click="changeActive" :data-id="item.id">
				<div style="width: 50%">{{item.name}}</div>
				<div style="display: flex; align-items: center; width: 40px; justify-content: space-between;">
                    <span style="font-size: 10px;" class="edit_blue icon iconfont icon-bianji"
						  
						  @click.stop="editRoleClick(item)"></span>
					<span v-if="item.type == 14"
						  class="edit_blue icon iconfont icon-iconzhuanqu_shanchu"
						  @click.stop="deleteRoleClick(item)"></span>
				</div>
			</div>
		</div>
		<!-- 操作日志 -->
		<div class="operation_log">
			<div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">操作日志</div>
			<Timeline>
				<TimelineItem v-for="item in logList">
					<p class="time">{{item.created_time}}</p>
					<p class="content">{{item.ext_info.remark}}</p>
				</TimelineItem>
			</Timeline>
		</div>

		<!-- 添加角色对话框 -->
		<Modal :footer-hide='true' v-model="addRoleShow">
			<div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">添加角色</div>
			<Form :model="roleForm" :label-width="130">
				<FormItem label="角色名称">
					<Input style="width: 300px;" v-model="roleForm.roleName" placeholder="请输入角色名称"></Input>
				</FormItem>
			</Form>
			<div style="display: flex; justify-content: flex-end;">
				<Button type="primary" @click="addOkClick">确认添加</Button>
			</div>
		</Modal>
		<!-- 编辑角色对话框 -->
		<Modal :footer-hide='true' v-model="editRoleShow">
			<div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">编辑角色-{{roleName}}</div>
			<Form :model="editForm" :label-width="80">
				<FormItem label="角色名称">
					<Input style="width: 300px;" v-model="editForm.name" placeholder="请输入角色名称"></Input>
				</FormItem>
			</Form>
			<div style="display: flex; justify-content: flex-end;">
				<Button type="primary" @click="editOkClick">确认修改</Button>
			</div>
		</Modal>
		<!-- 删除按钮对话框 -->
		<Modal :footer-hide='true' v-model="deleteRoleShow">
			<div style="color: #515A6E; font-weight: bold; margin-bottom: 20px;">删除信息-{{roleName}}</div>
			<div style="display: flex; justify-content: center;">确认将{{roleName}}从团队中移除吗?</div>
			<div style="display: flex; justify-content: flex-end;">
				<Button type="primary" @click="deleteOkClick">确认移除</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		deleteRole,saveRole
	} from '@/api/user'
	import {mapActions, mapGetters} from "vuex";
	export default {
		name: "RoleList",
		props: {
			'roleList': {
				type: Array
			},
			'logList': {
				type: Array
			}
		},
		computed:{
			...mapGetters(['token', 'userInfo'])
		},
		data() {
			return {
				activeId: 0,
				//添加角色对话框
				addRoleShow: false,
				//编辑角色对话款
				editRoleShow: false,
				//删除角色对话框
				deleteRoleShow: false,
				//点击编辑角色获取到的对应值
				roleName: '',
				// 要删除的id
				deleteRoleId: 0,
				roleForm: {
					roleName: '',
				},
				editForm: {
					id: 0,
					name: ''
				}
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			addRoleClick() {
				this.addRoleShow = true
			},
			//添加角色确认添加角色按钮
			addOkClick() {
				let that = this;
				let data = {token: this.token, name: this.roleForm.roleName}
				this.throttle(async function () {
					let res = await saveRole(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.addRoleShow = false;
						that.$emit('loadData');
					}
				}, 2000)
			},
			// 编辑角色确认按钮
			editOkClick() {
				let that = this;
				let data = {token: this.token, id: this.editForm.id, name: this.editForm.name}
				this.throttle(async function () {
					let res = await saveRole(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.editRoleShow = false;
						that.$emit('loadData');
					}
				}, 2000)
			},
			//删除角色确认移除按钮
			deleteOkClick() {
				let that = this;
				let data = {token: this.token, id: this.deleteRoleId}
				this.throttle(async function () {
					let res = await deleteRole(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.deleteRoleShow = false;
						that.$emit('loadData');
					}
				}, 2000)
			},
			//编辑
			editRoleClick(item) {
				this.editRoleShow = true
				this.roleName = item.name
				this.editForm.id = item.id;
				this.editForm.name = item.name
			},
			//删除
			deleteRoleClick(item) {
				this.deleteRoleShow = true
				this.deleteRoleId = item.id;
				this.roleName = item.name
			},
			changeActive(e) {
				let id = e.currentTarget.dataset.id;
				this.activeId = id;
				this.$emit('changeActiveId');
				this.$emit('getMemberList');
			}
		}
	}
</script>

<style scoped lang="less">
	.role {
		width: 325px;
		background-color: #FFFFFF;
		padding: 20px;
	}

	.edit_blue {
		color: #277dd3;
		cursor: pointer;
	}

	.operation_log {
		margin-top: 20px;
		width: 325px;
		background-color: #FFFFFF;
		padding: 20px;
	}
	.role-li {
		display: flex; align-items: center; justify-content: space-around; height: 50px;
	}
	.active {
		background: #f9f9f9;
	}
</style>
